import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoTableHeaderCheckboxComponent } from './avano-table-header-checkbox.component';

@NgModule({
  imports: [CommonModule],
  exports: [AvanoTableHeaderCheckboxComponent],
  declarations: [AvanoTableHeaderCheckboxComponent]
})
export class AvanoTableHeaderCheckboxModule {}
